import { getBuyerHeaderClient } from './header';
import { getBuyerFooterClient } from './footer';
import initializeTracking from '../utils/initializeTracking';
import { addLoginHandlers } from '../utils/loginHandlers';
import thunk from 'redux-thunk';
import { combineReducers, applyMiddleware, createStore, compose } from 'redux';
import dblReducers from '../reducers';
import NotificationQueue from '../notificationQueue/Queue';
import SV from 'server-vars';
import createRelayEnvironment from '../relayClientEnvironment';
import AuthModalCheck from '../utils/AuthModalCheck';
import isPageType from '../utils/isPageType';
import abExperiments from '../utils/abExperiments';
import pageTypes from '../utils/pageConstants';
import scriptInjector from '../utils/scriptInjector';
import AutoModal from '../abandonedCheckout/components/AutoModal';
import chatUtils from '../utils/chat';
import * as autoModalHelpers from '../abandonedCheckout/autoModalHelper';
import contactModal from '../contactModal/async';
import '../scss/dibs.scss';

import { isMasqueradingAsBuyer, cookieJarConstants } from 'dibs-cookie-jar';

import Cookies from 'js-cookie';

const { USER, MASQUERADE_BUYER, USER_EMAIL, USER_TYPE } = cookieJarConstants;

const dblMiddleware = [thunk];

// will be used to store the queue so that functions exported from dbl can interact with it
let queue;

function createGlobalStore(reducers, middlewares, state) {
    const reducer = combineReducers({ ...reducers, ...dblReducers });
    const middleware = middlewares
        .concat(dblMiddleware)
        .filter((value, index, self) => self.indexOf(value) === index);

    let enhancer;
    if (process.env.NODE_ENV !== 'production') {
        const { composeWithDevTools } = require('redux-devtools-extension');
        enhancer = composeWithDevTools;
    } else {
        enhancer = compose;
    }

    return createStore(reducer, state, enhancer(applyMiddleware(...middleware)));
}

Cookies.defaults = {
    domain: SV.get('cookieDomain'),
    expires: 182,
    path: '/',
};

function logoutFunc() {
    if (isMasqueradingAsBuyer(document.cookie)) {
        Cookies.remove(MASQUERADE_BUYER);
    } else {
        Cookies.remove(USER);
        Cookies.remove(USER_EMAIL);
        Cookies.remove(USER_TYPE);
    }
    location.reload();
}

function initialize({
    reducers = {},
    middleware = [],
    logoutUser = logoutFunc,
    notifications = [],
    state = {},
} = {}) {
    if (
        state.hasOwnProperty('cart') ||
        state.hasOwnProperty('header') ||
        state.hasOwnProperty('footer')
    ) {
        throw new Error('state cannot include cart, header, footer');
    }
    const data = JSON.parse(SV.get('headerRelayPreloadedData'));
    const relayEnv = createRelayEnvironment(data);
    const { header, cart } = SV.get('header') || {};
    const { footer } = SV.get('footer') || {};
    header.logoutUser = logoutUser;

    const store = createGlobalStore(reducers, middleware, { header, footer, cart, ...state });
    getBuyerHeaderClient({
        node: document.getElementById('js-header'),
        store,
        relayEnv,
    });
    getBuyerFooterClient({
        node: document.getElementById('js-footer'),
        store,
        relayEnv,
    });
    AuthModalCheck.init();
    queue = new NotificationQueue(notifications, store, relayEnv);
    chatUtils.start();
    return store;
}

function _getNotificationQueue() {
    return queue._getNotificationQueue();
}

function runNotificationQueue() {
    queue.runQueue();
}

// used only for testing notification order
export {
    abExperiments,
    addLoginHandlers,
    AutoModal,
    autoModalHelpers,
    contactModal,
    initializeTracking,
    initialize,
    isPageType,
    pageTypes,
    scriptInjector,
    _getNotificationQueue,
    runNotificationQueue,
};



// WEBPACK FOOTER //
// ./src/entries/index.jsx